module.exports = __webpack_public_path__ + "img/addImage.6e5e6a9c.png";